import {
  FETCH_CATEGORY_REQUEST,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
} from "./categoryActionTypes";

export const fetchCategoryRequest = () => ({ type: FETCH_CATEGORY_REQUEST });
export const fetchCategorySuccess = (data, dataType) => ({
  type: FETCH_CATEGORY_SUCCESS,
  payload: { data, type: dataType },
});
export const fetchCategoryFailure = (error) => ({
  type: FETCH_CATEGORY_FAILURE,
  payload: error,
});

export const createCategoryRequest = () => ({ type: CREATE_CATEGORY_REQUEST });
export const createCategorySuccess = (data, dataType) => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: { data, type: dataType },
});

export const createCategoryFailure = (error) => ({
  type: CREATE_CATEGORY_FAILURE,
  payload: error,
});

export const updateCategoryRequest = () => ({ type: UPDATE_CATEGORY_REQUEST });
export const updateCategorySuccess = (data, dataType) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: { data, type: dataType },
});
export const updateCategoryFailure = (error) => ({
  type: UPDATE_CATEGORY_FAILURE,
  payload: error,
});

export const deleteCategoryRequest = () => ({ type: DELETE_CATEGORY_REQUEST });
export const deleteCategorySuccess = (data, dataType) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: { data, type: dataType },
});
export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORY_FAILURE,
  payload: error,
});
